import React, { Component } from 'react'; 
import { Row, Col } from 'react-bootstrap';

//styles and images
// import flag from '../../images/flag.png';
import EmojiFlagsIcon from '@material-ui/icons/EmojiFlags';

// this component represents flag addon of the video recorder 

export default class Flag extends Component {
    
    handleOnclick = () => {
        // remove any flags first
        this.props.callbackFromParent(0 ,"remove flag");

        let flagBtn = document.querySelector('#FlagBtn').classList;
        let video = document.querySelector('video');
        let  start_time  = parseInt(video.currentTime);

        if (!flagBtn.contains('bg-orange')) {
            flagBtn.add("bg-orange");
            video.pause();
            console.log(start_time)
             this.props.callbackFromParent(start_time, "flag");
        } else {
            flagBtn.remove("bg-orange");
            this.props.callbackFromParent(start_time, "remove flag");
        }
    }
    viewFlag = (startTime) =>{
        let video = document.querySelector('video');
        video.currentTime = startTime || 1;
        video.pause();
    }
    componentWillReceiveProps(props){
        if(props !== this.props){
            if(props.startTime){
                this.viewFlag(props.startTime)
            }
        }
        // update flag when seeking video
        this.seekingFlag(props);
    }
    seekingFlag =(props)=> {
            let video = document.querySelector('video');
            let flagBtn = document.querySelector('#FlagBtn').classList;
            let  timeBeforeSeek  = parseInt(video.currentTime);
            video.onseeked = function(){
                let  start_time  = parseInt(video.currentTime);
                if(start_time === 0 ) start_time = 1 
                console.log(start_time)
                if(flagBtn.contains('bg-orange')) {
                    if(start_time !== timeBeforeSeek){
                        props.callbackFromParent(start_time , "flag");
                    }
                }
            }
        }
    render(){
        return(
            <div className="addon-flag">
                <div
                    className="p-absolute w-100 text-left"
                    style={{ top: '0.5rem', right: '1rem'}}
                >
                    <Row className="row m-0 justify-content-end align-items-center">
                    <Col xl={1} md={2} xs={3} className="text-right p-0">
                            <button
                                id='FlagBtn'
                                style={{ height: '3rem', width: '3rem', fontSize: '1.2rem' ,  zIndex: '1' }}
                                className="rounded-circle bg-dark-transperant p-2 p-relative border-0 text-white icon-responsive"
                                onClick={this.handleOnclick}
                            > 
                                <EmojiFlagsIcon />
                            </button>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}